import React, { useState } from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import AddIcon from "@mui/icons-material/Add";

import InternalWorkOrderItemModal from "./InternalWorkOrderItemModal";

export default function AddInternalWorkOrderAsset({ projectId, refetch, processNewItem, internalWorkOrderId }) {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
    if (refetch) {
      refetch();
    }
  };

  return (
    <>
      <Box mt={2}>
        <Button variant="outlined" onClick={() => setOpen(true)}>
          Add More Items
          <AddIcon color="primary" fontSize="small" />
        </Button>
      </Box>
      {open && <InternalWorkOrderItemModal projectId={projectId} onClose={handleClose} processNewItem={processNewItem} internalWorkOrderId={internalWorkOrderId} />}
    </>
  );
}
